module.exports = __webpack_public_path__ + "img/ring_g_0_null_0@3x.e431f736.png";